export class VariavelFormula{
  id: number;
  nome: string;
  formula: string;
  nativa: boolean;
}
